import { render, staticRenderFns } from "./MemberGuardianForm.vue?vue&type=template&id=aecdfefc"
import script from "./MemberGuardianForm.vue?vue&type=script&lang=js"
export * from "./MemberGuardianForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports